import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { Custom, Progress } from "components";
import { useApp } from "context";
import { IGoal } from "interfaces";

type Props = {
  opened: boolean;
  value: number[];
  onClose?: (healthGoalIds: number[]) => void;
};

export const FilterJourney = (props: Props) => {
  const { t, theme, service } = useApp();

  const [healthGoals, setHealthGoals] = useState<IGoal[]>([]);
  const [healthGoalIds, setHealthGoalIds] = useState<number[]>(props.value);

  const handleOpen = async () => {
    const [status, response] = await service.goal.all();
    setHealthGoals(response);
  };

  const handleClose = () => {
    props.onClose && props.onClose(healthGoalIds);
  };

  const handleCheckbox = (
    _: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
    value: number | undefined
  ) => {
    if (!value) return;
    checked
      ? setHealthGoalIds((prevIds) => [...prevIds, value])
      : setHealthGoalIds((prevIds) => prevIds.filter((id) => id !== value));
  };

  return (
    <Custom.Modal
      header={t.title.patient.filter_journey}
      opened={props.opened}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      <Grid container spacing={theme.margin.xs}>
        <Grid item xs={12}>
          {healthGoals && healthGoals.length > 0 ? (
            <Grid container spacing={theme.margin.sm}>
              {healthGoals.map((healthGoal: IGoal) => {
                return (
                  <Grid item key={healthGoal.healthGoalId}>
                    <Custom.Checkbox
                      id={healthGoal.healthGoalId}
                      label={healthGoal.healthGoal}
                      onChange={handleCheckbox}
                      checked={healthGoalIds.includes(healthGoal.healthGoalId)}
                    />
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <Box sx={{ position: "relative" }}>
              <Progress.NoRecord height={200} />
            </Box>
          )}
        </Grid>
      </Grid>
    </Custom.Modal>
  );
};
